import { Typography, Button } from 'antd';
import { HolderOutlined, CloseOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import classes from './DraggableCard.module.scss';

type DraggableCardProps = {
  cardText: string;
  handleDelete?: () => void;
  isDragging?: boolean;
  isDraggable?: boolean;
  isDeletable?: boolean;
};

export const DraggableCard = ({
  handleDelete,
  cardText,
  isDragging,
  isDraggable = false,
  isDeletable = false,
}: DraggableCardProps) => {
  return (
    <div className={classNames(classes.draggableCard, isDragging && classes.draggingCard)}>
      {isDraggable && <HolderOutlined className={classes.holderIcon} />}
      <Typography.Text ellipsis>{cardText}</Typography.Text>
      {isDeletable && (
        <Button
          type="link"
          icon={<CloseOutlined />}
          className={classes.deleteButton}
          onClick={handleDelete}
        />
      )}
    </div>
  );
};
